import { Component, OnInit, ElementRef, ViewChild, DoCheck, ViewContainerRef } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { NotificationsService } from '@shared/services/notification';
import { ImportDataService } from '@fs/services/import-data';
import { CommonService } from '@shared/services/common';
import { AuthService } from '@services/auth.service';
import { TabOpenService } from '@services/tab-open.service';
import { ISubscription } from 'rxjs/Subscription';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { CommonMethods } from 'src/app/services/common.method';

@Component({
  selector: 'app-import-data',
  templateUrl: './import-data.component.html',
  styleUrls: ['./import-data.component.scss']
})
export class ImportDataComponent implements OnInit, DoCheck {
  //#region Variable Declarations
  public fileUploading: boolean = false;
  public showAlert: boolean = false;
  public entities: any;
  public templateDic: any = {};
  public outputFilePath: string = "";
  public subtabCounter : number;
  public tabCounter: number;
  public isUnsavedTriggered: boolean;
  public doDownloadResultFile: boolean = false;
  private subscriptions: ISubscription[] = [];
  public importDataForm = new FormGroup({
    EntityId: new FormControl("", Validators.required),
    Notes: new FormControl(""),
    FilePath: new FormControl(""),
    FileName: new FormControl("")
  });
  public entityNames = ['Customer', 'Product','ServiceAgreement'];
   //#endregion

  //#region View child Declarations
  @ViewChild('importDeletePreview') importDeletePreview: ElementRef;
  @ViewChild('importDragAndDropFile') importDragAndDropFile: ElementRef;
  @ViewChild('filePreview') filePreview: ElementRef;
  @ViewChild('importUploadFileBtn') importUploadFileBtn: ElementRef;
  @ViewChild('importFileControl1') importFileControl1: ElementRef;
  @ViewChild('importFileControl2') importFileControl2: ElementRef;
 //#endregion
  
  //#region Constructor
 constructor(private toastr: NotificationsService,
    private importService: ImportDataService,
    private httpCommon: CommonService,
    private auth: AuthService,
    private tabOpen: TabOpenService,
    private showspinner: SpinnerService,
    private commonMethods : CommonMethods,
    private viewContainerRef: ViewContainerRef) {
    this.subtabCounter = this.commonMethods.generateDynamictabCounter();
    this.showspinner.showloader(this.viewContainerRef, this.subtabCounter);
    let _this = this;
    let subscription = this.httpCommon.GetIntialData(this.auth.getCompanyId(), "CodeTypeData").subscribe(
      response => {
        if(response.CodeTypeData.ExcelExportImportEntityType != null) {
          this.entities = response.CodeTypeData.ExcelExportImportEntityType.filter(x => this.entityNames.indexOf(x.Code)!=-1);
          if(this.entities.length > 0) {
            _this.templateDic[this.entities[0].ID] = "https://mpsuitedevstore.blob.core.windows.net/exportimportemplates/Template_Customer.xlsx";
            _this.templateDic[this.entities[1].ID] = "https://mpsuitedevstore.blob.core.windows.net/exportimportemplates/Template_Product.xlsx";
            _this.templateDic[this.entities[2].ID] = "https://mpsuitedevstore.blob.core.windows.net/exportimportemplates/Template_ServiceAgreement.xlsx";
          }
        }
        this.showspinner.hideLoader(this.viewContainerRef, this.subtabCounter);
      },(error:any)=>{this.showspinner.hideLoader(this.viewContainerRef, this.subtabCounter);}
    );
   this.subscriptions.push(subscription);
    subscription=this.tabOpen.alertPopupEvent.subscribe(res => {
      if (res) {
        if (res.data == this.tabCounter) {
          if (this.doDownloadResultFile) {
            this.showAlert = true;
          }
          else {
            this.tabOpen.DestroyTab(this.tabCounter, 'closeTab')
          }
        }
      }
    });
   this.subscriptions.push(subscription);
  }
    //#endregion

  //#region Lifecycle Events
  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      let isDirty = this.doDownloadResultFile;
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabOpen.unsavedChangedDetected({ dirty: isDirty, Index: this.tabCounter });
      }
    }
  }
  ngOnInit() {
  }

  ngOnDestroy(){
    this.DestroySubscriptions();
  }
  //#endregion

  //#region Methods
  public FileUploaded(selfRef, DragAndDropImage, UploadFileBtn, ImagePreview, DeletePreview) {
    this.importDataForm.markAsDirty();
    this.outputFilePath = "";
    if (this.isUnsavedTriggered) {
      this.doDownloadResultFile = false;
      this.tabOpen.unsavedChangedDetected({ dirty: false, Index: this.tabCounter });
      this.isUnsavedTriggered = false;
    }

    this.ReadURL(selfRef.target, DragAndDropImage, UploadFileBtn, ImagePreview, DeletePreview)
  }
  public ReadURL(input, DragAndDropFile, UploadFileBtn, FilePreview, DeletePreview) {
    let exts = ['.xls', '.xlsx'];
    if (input.files && input.files[0]) {
      if (!this.commonMethods.ValidExtension(input.value, exts)) {
        this.toastr.error("Sorry, uploaded file is invalid, allowed extensions are: " + exts.join(", "), "Error");
        $(input).val("");
        return;
      }
      let postData = new FormData();
      postData.append('files', input.files[0])
      this.fileUploading = true;
      this.showspinner.showloader(this.viewContainerRef, this.subtabCounter, 0);
      this.importService.UploadFile(this.importDataForm.controls["EntityId"].value, postData).subscribe(response => {
        if (response) {
          this.importDataForm.controls['FilePath'].patchValue(response.StorageLocation);
          this.importDataForm.controls['FileName'].patchValue(response.FileName);

          this.showspinner.hideLoader(this.viewContainerRef, this.subtabCounter);
          $(FilePreview).show();
          $(DragAndDropFile).hide();
          $(UploadFileBtn).show();
          $(DeletePreview).show()
          this.fileUploading = false;
        }

      }, error => {
        this.fileUploading = false;
        this.showspinner.hideLoader(this.viewContainerRef, this.subtabCounter);
        this.toastr.showMultiLineError(error.error.Message, "Error")
      });
    }
  }
  public RemovePreview(fileControl1, fileControl2, dragAndDropFile, uploadFileBtn, filePreview, deletePreview) {
    this.importDataForm.markAsDirty();
    $(fileControl1).val("");
    $(fileControl2).val("");
    this.importDataForm.controls['FilePath'].patchValue("")
    $(deletePreview).hide();
    $(filePreview).hide();
    $(dragAndDropFile).show();
    $(uploadFileBtn).hide();
  }
  public ProcessFile() {
    let data = {
      InputFilePath: this.importDataForm.controls['FilePath'].value,
      EntityTypeId: this.importDataForm.controls['EntityId'].value
    }
    this.outputFilePath = "";
    this.fileUploading = true;
    this.showspinner.showloader(this.viewContainerRef, this.subtabCounter, 0);
    this.importService.ProcessFile(data).subscribe(res => {
      if (res) {
        this.outputFilePath = res.OutputFilePath;
        this.doDownloadResultFile = true;
        this.importDataForm.reset();
        $(this.importFileControl2.nativeElement).val("");
        this.importDataForm.controls["FilePath"].patchValue("");
        this.importDataForm.controls['EntityId'].patchValue("");
        $(this.importDeletePreview.nativeElement).hide();
        $(this.filePreview.nativeElement).hide();
        $(this.importDragAndDropFile.nativeElement).show();
        $(this.importUploadFileBtn.nativeElement).hide();
        this.fileUploading = false;
        this.showspinner.hideLoader(this.viewContainerRef, this.subtabCounter);
        this.toastr.success("Please click on the below link to download the result template", "Success!");
      }
    }
      , error => {
        this.fileUploading = false;
        this.showspinner.hideLoader(this.viewContainerRef, this.subtabCounter);
        this.toastr.showMultiLineError(error.error.Message, "Error")
      }
    );
  }

  public CloseTab() {
    this.tabOpen.DestroyTab(this.tabCounter, 'closeTab');
  }
  public KeepTabOpen() {
    this.showAlert = false;
  }
  public ResultDownloaded() {
    this.doDownloadResultFile = false;
    this.tabOpen.unsavedChangedDetected({ dirty: false, Index: this.tabCounter });
    this.isUnsavedTriggered = false;
  }

  private DestroySubscriptions() {
    this.subscriptions.forEach(element => {      
      element.unsubscribe();
    });
  }
    //#endregion
}
